import { List, ListItem, ListItemIcon, ListItemText, Box } from "@mui/material";
import { Link } from "react-router-dom";
import {
  MdDashboard,
  MdLocationOn,
  MdBusiness,
  MdInventory2,
} from "react-icons/md";
import { FaAngleRight, FaUsers } from "react-icons/fa";

const SideBar = () => {
  return (
    <div>
      <Box
        sx={{
          width: { xs: "200px", md: "250px" },
          height: "100vh",
          backgroundColor: "#2c3e50",
          color: "#ecf0f1",
          paddingTop: "20px",
          overflowY: "auto",
          boxShadow: "2px 0 10px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <List>
          {/* Dashboard */}
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <ListItem
              button
              sx={{
                "&:hover": { backgroundColor: "#34495e" },
              }}
            >
              <ListItemIcon sx={{ color: "#ecf0f1" }}>
                <MdDashboard />
              </ListItemIcon>
              <ListItemText primary="GPS Device" />
              <FaAngleRight style={{ color: "#ecf0f1" }} />
            </ListItem>
          </Link>

          {/* Routers */}
          <Link
            to="/PostGetRouter"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItem
              button
              sx={{
                "&:hover": { backgroundColor: "#34495e" },
              }}
            >
              <ListItemIcon sx={{ color: "#ecf0f1" }}>
                <FaUsers />
              </ListItemIcon>
              <ListItemText primary="Routers" />
              <FaAngleRight style={{ color: "#ecf0f1" }} />
            </ListItem>
          </Link>

          {/* Location */}
          <Link to="/Maps" style={{ textDecoration: "none", color: "inherit" }}>
            <ListItem
              button
              sx={{
                "&:hover": { backgroundColor: "#34495e" },
              }}
            >
              <ListItemIcon sx={{ color: "#ecf0f1" }}>
                <MdLocationOn />
              </ListItemIcon>
              <ListItemText primary="Location" />
              <FaAngleRight style={{ color: "#ecf0f1" }} />
            </ListItem>
          </Link>

          {/* Brands */}
          <Link
            to="/admin/brands"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItem
              button
              sx={{
                "&:hover": { backgroundColor: "#34495e" },
              }}
            >
              <ListItemIcon sx={{ color: "#ecf0f1" }}>
                <MdBusiness />
              </ListItemIcon>
              <ListItemText primary="Brands" />
              <FaAngleRight style={{ color: "#ecf0f1" }} />
            </ListItem>
          </Link>

          {/* Products */}
          <Link
            to="/admin/products"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItem
              button
              sx={{
                "&:hover": { backgroundColor: "#34495e" },
              }}
            >
              <ListItemIcon sx={{ color: "#ecf0f1" }}>
                <MdInventory2 />
              </ListItemIcon>
              <ListItemText primary="Products" />
              <FaAngleRight style={{ color: "#ecf0f1" }} />
            </ListItem>
          </Link>
        </List>
      </Box>
    </div>
  );
};

export default SideBar;
